import { merge } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    PAGES,
    SOURCE_PAGE_LOGO_MAKER_FORK,
    TRACKING_STATIC_CONTEXT,
} from '../constants';

const sharedPayload = {
    page: {
        element: {
            name: 'Logo Maker Fork',
        },
        component: {
            name: 'logo_maker_fork',
        },
    },
    item_context: {
        source_page: SOURCE_PAGE_LOGO_MAKER_FORK,
    },
};

const enrichWithFiverrContextData = () => {
    const { userId, pageCtxId, userGuid } = getContext();

    return {
        uid: userGuid,
        user: { id: userId },
        page: { ctx_id: pageCtxId },
    };
};

export const getBQPayload = (payload) =>
    merge({}, enrichWithFiverrContextData(), sharedPayload, payload);

export const getMarketplaceIntegrationBqPayload = (payload) => {
    const {
        userId,
        userGuid,
        pageCtxId,
        referrer,
        queryParameters: { ref_ctx_id = '' },
    } = getContext();

    const sharedPayload = {
        ...TRACKING_STATIC_CONTEXT,
        user: {
            id: userId,
        },
        uid: userGuid,
        page: {
            name: PAGES.SUB_CATEGORIES,
            referrer: {
                ctx_id: ref_ctx_id,
            },
        },
        pageCtxId,
        url: window.location.href,
        referrer,
    };

    return merge({}, sharedPayload, payload);
};

export const getMarketplaceIntegrationImpressionEnrichment = (payload) => {
    const {
        pageCtxId,
        queryParameters: { ref_ctx_id = '' },
    } = getContext();
    return {
        page: {
            name: PAGES.SUB_CATEGORIES,
            referrer: {
                ctx_id: ref_ctx_id,
            },
        },
        gig_impression: [
            {
                listings: {
                    page_ctx_id: pageCtxId,
                },
            },
        ],
        ...payload,
    };
};
